import http from '../../http/base';
import { API_PATHS } from '../../http/configs';

export default {
    getMemberHasActiveFacilityEnrollments: membersGuids => http.get(API_PATHS.memberHasActiveFacilityEnrollments, { params: { membersGuids } }),
    getMemberInvalidations: membersGuids => http.get(API_PATHS.getMemberInvalidations, { params: { membersGuids } })
};